/** Inspect real product photography without leaving the purchase page. */
class LightingViewer extends HTMLElement {
  #dialog;
  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    this.addEventListener('click', this.#onClick);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    if (this.#dialog?.open) this.#dialog.close();
  }
  #setZoom(magnified) {
    const viewport = this.querySelector('[data-lighting-window]');
    const button = this.querySelector('[data-lighting-magnify]');
    if (!viewport || !button) return;
    viewport.dataset.zoomed = String(magnified);
    button.setAttribute('aria-pressed', String(magnified));
    button.textContent = magnified ? this.dataset.labelFit : this.dataset.labelMagnify;
    viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2;
    viewport.scrollTop = (viewport.scrollHeight - viewport.clientHeight) / 2;
  }
  #onClick = (event) => {
    if (event.target.closest('[data-lighting-close]') || event.target === this.#dialog) {
      this.#dialog?.close();
      return;
    }
    if (event.target.closest('[data-lighting-magnify]')) {
      this.#setZoom(this.querySelector('[data-lighting-window]')?.dataset.zoomed !== 'true');
      return;
    }
    if (!event.target.closest('[data-lighting-zoom]') || !this.#dialog?.showModal) return;
    const main = this.querySelector('tt-gallery img[ref="main"]');
    const enlarged = this.querySelector('[data-lighting-enlarged]');
    if (!main || !enlarged) return;
    event.preventDefault();
    enlarged.src = main.src;
    enlarged.alt = main.alt;
    enlarged.width = main.naturalWidth || 1600;
    enlarged.height = main.naturalHeight || 1600;
    this.#dialog.showModal();
    this.#setZoom(true);
  };
}
if (!customElements.get('tt-lighting-viewer')) customElements.define('tt-lighting-viewer', LightingViewer);
